/**
 * The time limit of the requests of the session's query queue: table
 * scripts, banner builds, the REMOVEs after a failure, and their polls. The
 * session's own requests (opening the data, RESET, the preparation,
 * CODEBOOK) have none, as in the dashboards and the console: a file or a
 * preparation that takes longer must still open, and Restart overtakes them.
 */

/** How long one request of the queue may take. */
export const ENGINE_TIMEOUT_MS = 5 * 60 * 1000
/** A table's error when the engine did not answer in that time. */
export const ENGINE_TIMEOUT = "The engine did not answer within 5 minutes."

/** A request of the queue that got no answer within `ENGINE_TIMEOUT_MS`. */
export class EngineTimeoutError extends Error {
  constructor() {
    super(ENGINE_TIMEOUT)
    this.name = "EngineTimeoutError"
  }
}
